import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import SystemIdentity from "./sections/SystemIdentity";
import ContactForm from "./sections/ContactForm";
import CommonInquiries from "./sections/CommonInquiries";
import ContactMap from "./sections/ContactMap";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <SystemIdentity />
      <ContactForm />
      <CommonInquiries />
      <ContactMap />
      <Footer />
    </div>;
}